module.exports = __webpack_public_path__ + "static/media/hungary-flag.5ebb24fd.png";